var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexChart',{attrs:{"type":"line","height":"350","options":_vm.chartOptionsBalance,"series":_vm.balanceData}}),_c('apexChart',{attrs:{"type":"line","height":"200","options":_vm.chartOptionsClients,"series":_vm.clientsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }